import SlidingCheckbox from "shared-components-package/dist/components/SlidingCheckbox";

function YellowToggleWithIcon({ text, isChecked, setIsChecked, svg }) {
  return (
    <div className="profile-yellow-toggle">
      {svg}

      <span className="profile-text-toggle">{text}</span>
      <SlidingCheckbox {...{ isChecked, setIsChecked }} />
    </div>
  );
}

export default YellowToggleWithIcon;
